import { OrderItemGroupData } from '../../../../app/data/model';
import Image from '../../../../app/shared/components/Image/Image';
import { Panel } from '../../../../app/shared/components/Panel/Panel';
import { CartItemDetails } from '../../../cart/CartItem/CartItemDetails/CartItemDetails';
import { OrderItemTranslation } from '../../../localization/SiteTranslation';
import css from './OrderItemGroup.css';

interface OrderItemGroup {
  item: OrderItemGroupData;
  translation: OrderItemTranslation;
}

export const OrderItemGroup = ({ item, translation }: OrderItemGroup) => {
  return (
    <Panel headerComponent={<div className={css.panelHeader}>{item.name}</div>} bodyClassName={css.panelBody}>
      <Image
        className={css.image}
        src={item.imageUrl}
        width={80}
        height={140}
        sharpeningFactor={1.5}
        scalingMode="fit"
      />
      <CartItemDetails
        code={item.modularCode}
        listPrice={item.listPrice}
        salePrice={item.salePrice}
        quantity={item.quantity}
        className={css.details}
        propertyClassNames={{
          valueClassName: css.propertyValue,
        }}
        translation={translation.cartItemDetails}
      />
    </Panel>
  );
};
